export function simReducer(state = null,{
    type,
    payload
}){
    switch(type){
        case "GET_SIMS":
            return payload;
        
        default:
            return state;
    }
}